<template>
  <div id="new_user">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>企業情報入力</h2>
          <label>下記フォームより入力してください。</label>
        </div>
        <dd-corp-input
          ref="corpInputRef"
          :isEdit="false"
          :corpForm="corpForm"
          :isManager="true"
          :inviteErrMessage="inviteErrMessage"
        />
        <div id="regist_btn">
          <button class="main_btn" @click="confirm()">次へ</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import CorpInput from '../components/user/CorpInput'

export default {
  name: 'RegistCorpInput',
  components: {
    'dd-header': Header,
    'dd-corp-input': CorpInput
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      corpForm: {
        corpId: '',
        corpName: '',
        corpBranchName: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        inviteCode: '',
        requestPayment: ''
      },
      inviteErrMessage: ''
    }
  },
  computed: {
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    confirm: function () {
      let ret = this.$refs.corpInputRef.confirm()
      if (!ret) return

      // ストレージに保存する
      App.setLocalStorage(DC_STORAGE_KEY.CORP_DATA, this.corpForm)
      if (this.corpForm.inviteCode && this.corpForm.inviteCode.length > 0) {
        let payload = {
          params: {
            inviteCode: this.corpForm.inviteCode
          }
        }
        axios.get(DC_URL.USER + '/new/check-invitecode', payload)
          .then(response => {
            if (response.data.errorMessage) {
              this.inviteErrMessage = response.data.errorMessage
            } else {
              this.$router.push({
                name: 'RegistUserInput'
              })
            }
          }).catch(error => {
            Api.handleError(error)
          })
      } else {
        this.$router.push({
          name: 'RegistUserInput'
        })
      }
    },
    tokenCheck: function () {
      let payload = {
        userEmail: this.$route.query.email,
        token: this.$route.query.token
      }
      axios.post(DC_URL.USER + '/new/check-new-user-token', payload)
        .then(response => {
        }).catch(error => {
          Api.handleError(error)
        })
    }
  },
  mounted () {
    this.tokenCheck()
    let lForm = App.getLocalStorage(DC_STORAGE_KEY.CORP_DATA)
    if (Object.keys(lForm).length > 0) {
      this.corpForm = lForm
    } else {
      this.$set(this.corpForm, 'email', this.$route.query.email)
      this.$set(this.corpForm, 'inviteCode', this.$route.query.code)
      this.$set(this.corpForm, 'requestPayment', this.$route.query.payment)
      App.setLocalStorage(DC_STORAGE_KEY.CORP_DATA, this.corpForm)
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/RegistCorpInput.vue